import { render, staticRenderFns } from "./AccordionPanelV2.vue?vue&type=template&id=45f62ada&scoped=true&"
import script from "./AccordionPanelV2.vue?vue&type=script&lang=js&"
export * from "./AccordionPanelV2.vue?vue&type=script&lang=js&"
import style0 from "./AccordionPanelV2.vue?vue&type=style&index=0&id=45f62ada&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f62ada",
  null
  
)

export default component.exports